module.exports = __webpack_public_path__ + "media/about/alex-wieck-78911d26.jpg";